module.exports = __webpack_public_path__ + "img/movie.37e86fdc.webp";